<!--HEADER-->
<div class="additional-booking-confirm__header row" id="additionalBookingConfirmHeader">
  <div class="additional-booking-confirm__header-col col-12">
    <h3 class="additional-booking-confirm__intro"
        *appApplyIfNotEmpty="translationService.getTranslation('additionalBooking_confirm_intro')"
        [innerHTML]="translationService.getTranslation('additionalBooking_confirm_intro')"></h3>
  </div>
  <div class="additional-booking-confirm__header-col col-12" *ngIf="isQualified">
    <p class="additional-booking-confirm__description"
       *appApplyIfNotEmpty="translationService.getTranslation('additionalBooking_confirm_description')"
       [innerHTML]="translationService.getTranslation('additionalBooking_confirm_description')"></p>
  </div>
</div>

<div class="additional-booking-confirm__content row">
  <div class="additional-booking-confirm__content-col col-12">

    <div class="additional-booking-confirm__spinner" style="text-align: center;" *ngIf="isLoading">
      <app-loading-spinner></app-loading-spinner>
    </div>

    <ng-container *ngIf="!isLoading">
      <app-general-errors [errors]="errors"></app-general-errors>

      <!--PRODUKT, DAS GEBUCHT WIRD-->
      <mat-card appearance="outlined" class="mt-3" *ngIf="isQualified && product">
        <div class="row m-3">
          <div tabindex="0" class="col-12">
            <mat-card-subtitle class="additional-booking-confirm__product-label"
                               [innerHTML]="translationService.getTranslation('additionalBooking_confirm_product_label')">
            </mat-card-subtitle>
            <mat-card-title>{{ product.description }}</mat-card-title>
          </div>
        </div>
      </mat-card>
    </ng-container>

    <!--LAUFENDE BESTELLUNG: Kopf und Produkt bleiben stehen, bis auf die Bestaetigungsseite
        navigiert wird - eine leere Seite waehrend der Anlage waere nicht nachvollziehbar.-->
    <div class="additional-booking-confirm__spinner" style="text-align: center;" *ngIf="isBooking">
      <app-loading-spinner></app-loading-spinner>
    </div>

    <!--AKTIONEN-->
    <div class="additional-booking-confirm__actions" *ngIf="!isLoading && !isBooking">
      <button mat-raised-button (click)="goBack()"
      [innerHTML]="translationService.getTranslation('button_back')"></button>
      <button mat-raised-button color="primary" *ngIf="isQualified"
              [disabled]="!canConfirm" (click)="confirmBooking()"
              [innerHTML]="translationService.getTranslation('additionalBooking_button_confirm')"></button>
    </div>
  </div>
</div>
